import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import { IGetSectorsData } from "@/src-refactor/modules/store/qrtk/services/geoLocation/responses/get-sectors.response";

export type sectorAutoCompleteItem = I_GENERIC_ITEMS<{
  city: string;
}>;

interface argSectorAutoCompleteItemAdapter extends IGetSectorsData {}

const sectorAutoCompleteItemAdapter: (
  arg: argSectorAutoCompleteItemAdapter
) => sectorAutoCompleteItem = arg => {
  return {
    label: arg.description,
    value: arg.id,
    id: arg.id,
    name: arg.description,
    extraData: {
      city: arg?.city?.description
    }
  };
};

export { sectorAutoCompleteItemAdapter };
